var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.641114 8.46756L0.015652 11.1719C-0.00592432 11.2708 -0.00518466 11.3732 0.0178169 11.4718C0.0408184 11.5703 0.0855008 11.6624 0.1486 11.7415C0.211699 11.8205 0.291621 11.8844 0.382527 11.9285C0.473433 11.9726 0.573027 11.9958 0.674033 11.9964C0.721097 12.0012 0.76852 12.0012 0.815585 11.9964L3.53141 11.3698L10.159 4.74999L7.25105 1.84327L7.24892 1.84114L0.641114 8.46756ZM7.25037 3.489L1.70078 9.05389L1.32371 10.6843L2.94463 10.3103L8.51126 4.74936L7.25037 3.489ZM11.8016 3.11088C11.8648 3.04725 11.9149 2.97177 11.9489 2.88875C11.9829 2.80572 12.0003 2.71679 12 2.62704C11.9997 2.53728 11.9817 2.44847 11.9471 2.36568C11.9125 2.28289 11.862 2.20775 11.7983 2.14456L9.85612 0.198734C9.72842 0.0714521 9.55562 0 9.3755 0C9.19537 0 9.02257 0.0714521 8.89488 0.198734L7.81521 1.28041L10.7219 4.19263L11.8016 3.11088Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconWhite);
export default __webpack_public_path__ + "static/media/editIconWhite.88fae65f25f8d65709572380a460cab5.svg";
export { ForwardRef as ReactComponent };